const products = {
    "125cm Luxury Wall Art for Bedroom & Living Room – Canvas Painting (Set of 2)": 10000,
    "Airplane Crochet Pattern Toy": 790,
    "Alex Ceramic Table Lamp": 1500,
    "Amethyst Crystal Soap Handmade with jasmine": 799,
    "Animals Wall Decor on Polyresin": 1800,
    "Artificial Earrings": 1800,
    "Asymmetrical Metal Framed Wall Accent Mirror": 7000,
    "Avante - Light Pendant": 4500,
    "Bella HAY Side Table 60x39cm": 6999,
    "Black Onyx Adjustable Ring Leaf Ring For Women": 1900,
    "Bluetooth Headset – Black": 399,
    "Bora armchair": 4999,
    "Bottle Grinder, Bronzed Brass": 1149,
    "Bright Football Fully Reversible Eyelet Curtains": 2100,
    "Carrie Table Lamp": 1200,
    "Coffee Table with Storage": 15000,
    "Cordless 7 Speed Hand Mixer (Charcoal Grey)": 1999,
    "Cotton Hand Block Printed Jacket": 2500,
    "Cotton Women’s Quilted Jacket Block Printed Boho": 4900,
    "Cucumber + Mint Soap – Natural Pure Vegan": 599,
    "Daxtin Metal Wall Decor": 15000,
    "Denim Style Linen Jacket for Women": 3500,
    "Doroty Console Table – Gold": 25000,
    "Dramatic Floral Shower Curtain": 2100,
    "Embroidered Floral Summer Boho Jacket for Women – Free Size": 4999,
    "Embroidered White Summer Boho Jacket for Women – Free Size": 4500,
    "Faux Plant in Pot Liner": 2100,
    "Floral Square Throw Cushion With Filling": 999,
    "Flower Almond Press On Nails Chrome False Nails": 1299,
    "Gaming Console 5 Digital Edition": 49999,
    "Golden Iron LED Flush Mounted Sconce": 3500,
    "Golden Side Table With Glass Top": 3500,
    "Grip Boost Tour Hyper Touch Men’s Golf Glove 2.0": 1200,
    "Horse print kaftan vintage theme": 3400,
    "Ikat Pale Pink/Teal Rug": 22000,
    "Jacquard Linen Geometric Pattern Kimono Style Jacket": 3900,
    "Jungle Quilted Jacket Hand Printed Boho Style Quilted": 4500,
    "Kastilo Asymmetrical Modern Velvet 2 Seater": 41000,
    "KettlebellConnect 2.0 – Adjustable Kettlebell – Cool": 1599,
    "Knife Gemstone Dangle Earrings For Womens": 3500,
    "Lex Black Dome USB Desk Lamp": 900,
    "Light Black LED Kitchen Island Pendant": 14000,
    "Lightning Mqueen Crochet Pattern": 650,
    "Lightning to USB-A Cable + Strap, Silver": 699,
    "Linen Shirt For Women – Free Size": 999,
    "M-Cuisine Microwave Cooking Set": 600,
    "Magic Mouse 2 (Wireless, Rechargable) – Space Grey": 9900,
    "Menageri pepper mill h 9.5 cm, oak matt lacquered": 1100,
    "Mi Smart Band 5": 999,
    "Minimalist Oval Solitaire Ring": 8900,
    "Mint Green Linen Cropped Shirt Jacket With Buttons": 1900,
    "Mint Soap, Skin Soap, Handmade Soap": 1180,
    "Mophie powerstation USB-C 3XL Battery": 5500,
    "Morganite Crystal Soap – Polished Agate Square": 1299,
    "Natural Skincare Face Kit | Face Cleansing Oil": 3500,
    "NFL _The Duke_ Replica Composite Football, Official": 1900,
    "Olivine -Green Matte Eyeshadow": 899,
    "Open Copper Ring With Artificial (Imitated) Green": 1199,
    "Organic Skincare Kit, Cleanse & Glow Natural": 8400,
    "Organic Skincare samples by Natural Wisdom Spa": 899,
    "People Figurines & Sculptures": 899,
    "Personalised Breath Bear": 2800,
    "Plants & Flowers Wall Decor on Metal": 2400,
    "Printed Kaftan Long Wear Dress Beach Wear Maxi": 3199,
    "Professional Handheld Percussive Therapy Device": 1990,
    "Puffin Rock Soft Toy": 1300,
    "Right Flowers Wall Décor Metal": 2400,
    "Round Metal Swirl Framed Wall Mounted Accent Mirror": 9000,
    "Saturn Manufactured Wood Bedside Table": 11000,
    "Shea Butter Pure and Natural": 1399,
    "Sheer 2 Seater Upholstered Sofa": 38000,
    "Sleepy Dino Fully Reversible Eyelet Curtains": 2400,
    "Slim Single-Serve K-Cup Pod Coffee Maker – Black": 14999,
    "Snazzy Flowers – Single Picture Frame Print": 2500,
    "Soft spot solar lamp 24.5 cm (anthracite)": 1000,
    "Solo Silhouette Storage Jars (1.5 Liter)": 1100,
    "SoundLink® Revolve+ Bluetooth Speaker": 28000,
    "Strawberry Scented Lipgloss": 890,
    "Stuffed Animals Soft Toy": 890,
    "Stunning Flower Jewellery Set for Mehndi": 1299,
    "Surface Laptop Go, 12.4 Touchscreen Core i5 Ice Blue": 85000,
    "Teller Polyester Shower Curtain": 2700,
    "Terracotta Large Oval Lidded Casserole Dish": 800,
    "Thin Band Ring With Artificial Diamond": 1400,
    "ThinkPad X1 Carbon Gen 8 (14”) Laptop": 199999,
    "Timeless and elegant modular sofa": 10999,
    "Traditional Moroccan Lipstick Aker Fassi, Natural": 3499,
    "Unique Tiered LED Chandelier": 34000,
    "Universal Controller Holder, compatible with Xbox, PS4, PS5, Switch Pro": 900,
    "Vegan Natural Mineral Makeup Foundation 8g Talc Free": 1399,
    "Vintage Rug – Machine Woven Runner": 21000,
    "Whisper Rug Digitally Printed Beige": 22450,
    "White Linen Top With Traditional Pattern": 1700,
    "Wilson Evolution Official Game Basketball": 1950,
    "Wilson Ultra Power XL 112 Tennis Racket": 1200,
    "Wire Pot BY NORM ARCHITECTS": 1300,
    "XPS 15 9570 Gaming Laptop i7-8750H IPS Display": 68000,
    "Yellow Flowers Beauty – Wrapped Canvas Print": 2600,
    "Zircon Jewellery Set With Necklace, Bracelet and Earring": 12000
};

const findCombinations = (
    targetAmount,
    currentProducts = {},
    currentSum = 0,
    combinations = [],
    limit = 10
) => {
    const productNames = Object.keys(products);
    const productPrices = Object.values(products);

    if (currentSum >= targetAmount && currentSum <= targetAmount + 100) {
        const combinationResult = {
            balance: currentSum - targetAmount,
            products: {},
        };

        for (const [name, details] of Object.entries(currentProducts)) {
            combinationResult.products[name] = {
                quantity: details.quantity,
                price: details.price,
            };
        }

        combinations.push(combinationResult);

        if (combinations.length >= limit) {
            return combinations;
        }
    }

    if (currentSum > targetAmount + 100) {
        return combinations;
    }

    for (let i = 0; i < productNames.length; i++) {
        const productName = productNames[i];
        const productPrice = productPrices[i];

        if (!currentProducts[productName]) {
            currentProducts[productName] = { quantity: 0, price: productPrice };
        }

        currentProducts[productName].quantity++;

        combinations = findCombinations(
            targetAmount,
            currentProducts,
            currentSum + productPrice,
            combinations,
            limit
        );

        currentProducts[productName].quantity--;

        if (currentProducts[productName].quantity === 0) {
            delete currentProducts[productName];
        }

        if (combinations.length >= limit) break;
    }

    return combinations;
};

export const getProductCombinations = (userInput) => {
    const amount = Number(userInput.split(".")[0]);

    const combinations = findCombinations(amount);

    if (combinations.length === 0)
        throw new Error("No valid combinations found within the specified range.");

    return combinations[combinations.length - 1]
};  